import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import SingleDocument from "./SingleDocument";

const EmancipationCertificate = (props) => (
  <SingleDocument
    {...props}
    formKey={SUBSCRIPTION_FORM_KEYS.PROOF.EMANCIPATION_CERTIFICATE}
    field="emancipationCertificate"
  />
);

export default EmancipationCertificate;
